import type { TalentProfileListItem, ExpertiseOffering } from './talent'
import type { SeekerProfileListItem } from './seeker'

export type ServiceRequestStatus =
  | 'new'
  | 'accepted'
  | 'awaiting_payment'
  | 'declined'
  | 'declined_requester'
  | 'in_progress'
  | 'completed'
  | 'refunded'

export interface ServiceRequest {
  id: string
  seeker: SeekerProfileListItem
  talent: TalentProfileListItem
  service_type: ExpertiseOffering | null
  message: string
  requester_full_name: string
  requester_email: string
  requester_organization_type: string
  request_type: string
  topic: string
  intended_audience: string[]
  status: ServiceRequestStatus
  price_cents: number | null
  currency: string
  price_display: string | null
  expert_message: string
  responded_at: string | null
  accepted_at: string | null
  paid_at: string | null
  completed_at: string | null
  refunded_at: string | null
  refund_reason: string
  platform_fee_cents: number | null
  expert_payout_cents: number | null
  created_at: string
  updated_at: string
}

export interface ServiceRequestListItem {
  id: string
  seeker_company: string
  talent_display_id: string
  service_type_name: string | null
  status: ServiceRequestStatus
  price_cents: number | null
  currency: string
  price_display: string | null
  created_at: string
  responded_at: string | null
  accepted_at: string | null
  paid_at: string | null
}

export interface CreateServiceRequest {
  talent_id: string
  service_type_id?: number | null
  message: string
  requester_full_name?: string
  requester_email?: string
  requester_organization_type?: string
  request_type?: string
  topic?: string
  intended_audience?: string[]
}

export const AUDIENCE_OPTIONS: { value: string; label: string }[] = [
  { value: 'undergraduate', label: 'Undergraduate students' },
  { value: 'masters', label: "Master's students" },
  { value: 'phd', label: 'PhD students' },
  { value: 'academic_staff', label: 'Academic staff' },
  { value: 'mixed', label: 'Mixed / multidisciplinary audience' },
  { value: 'research_group', label: 'Research group' },
]

export interface SetPriceRequest {
  price_cents: number
  message?: string
}

export interface DeclineRequest {
  message?: string
}

export interface AcceptRequest {
  message?: string
}
